import * as React from "react";
import './TextCtl.scss'

interface ITextProps {
    type?: string;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: string;
    onChange?: (value: string) => void;
    maxLength?: number;
    hintText?: string;
}

export default class TextCtl extends React.PureComponent<ITextProps> {

    onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => this.props.onChange?.(e.target.value);
    onTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => this.props.onChange?.(e.target.value);

    render() {
        switch (this.props.type ?? "text") {
        case "textarea":
            return <textarea className={`${this.props.className}${this.props.disabled ? " disabled" : ""}`}
                        placeholder={this.props.placeholder} 
                        onChange={this.onTextAreaChange}
                        title={this.props.hintText}
                        disabled={this.props.disabled} value={this.props.value} />;
        default:
                return <input className={`${this.props.className}${this.props.disabled ? " disabled" : ""}`}
                        maxLength={this.props.maxLength}
                        type={this.props.type ?? "text"}
                        value={this.props.value}
                        title={this.props.hintText}
                        placeholder={this.props.placeholder}
                        onChange={this.onInputChange}
                        disabled={this.props.disabled}/>;
        }
    }
}